"use client"
/* */
const Wrap = (props) => {
  const { if: _if, children } = props;
  if (_if) {
    return children;
  }
  return children.props.children;
};

export { Wrap, Wrap as default };
//# sourceMappingURL=Wrap.mjs.map
